export const ASPIRATIONAL_PROOF_FLAG = "aspirational_proof_v1";
export const ASPIRATIONAL_PROOF_CAMPAIGN = "aspirational_proof_v1";

export function getProofCampaign(search: URLSearchParams) {
  const postId = search.get("utm_content");
  if (
    ["utm_source", "utm_medium", "utm_campaign", "placement", "via", "utm_content"].some((key) => search.getAll(key).length > 1) ||
    !["matt", "tj", "cine"].includes(search.get("via") ?? "") ||
    search.get("utm_source") !== "twitter" ||
    search.get("utm_medium") !== "organic_social" ||
    search.get("utm_campaign") !== ASPIRATIONAL_PROOF_CAMPAIGN ||
    search.get("placement") !== "reply" ||
    (postId !== null && !/^\d{15,22}$/.test(postId))
  ) return null;
  return { postId, placement: "reply" as const };
}
